// src/components/EpisodeTable.tsx
import { useMemo, useState } from "react";
import { Edit3, MoreHorizontal } from "lucide-react";
import { Switch } from "@mui/material";
import Tape from "assets/img/svg/Tape.svg";
import { useNavigate } from "react-router-dom";
import type { Episode as EpisodeT, Season as SeasonT } from "./types";

type Row = {
  id: number;
  title: string;
  description?: string;
  size?: string;
  duration?: string;
  active: boolean;
};

export default function EpisodeTable({
  movieId,
  season,
  episodes = [] as EpisodeT[],
  details,
}: {
  movieId: any;
  season?: SeasonT;
  episodes?: EpisodeT[];
  details?: any;
}) {
  const initialRows: Row[] = useMemo(
    () =>
      (episodes || []).map((ep) => ({
        id: ep.id,
        title: ep.title,
        description: ep.description,
        size: ep.size,
        duration: ep.duration,
        active:
          (ep.status || "").toLowerCase() === "active" ||
          (ep.status || "").toLowerCase() === "published",
      })),
    [episodes]
  );

  const [rows, setRows] = useState<Row[]>(initialRows);

  const toggleStatus = (id: number) => {
    setRows((prev) =>
      prev.map((r) => (r.id === id ? { ...r, active: !r.active } : r))
    );
  };
  const navigate = useNavigate();
  const mediaId = movieId || details?.id || "";
  const seasonId = season?.id || details?.seasonId || "";
  console.log(details);

  return (
    <div className="w-100 mx-auto bg-white rounded-lg overflow-hidden">
      {rows?.length > 0 ? (
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b">
            <tr className="text-left text-gray-600">
              <th className="p-3 w-8">#</th>
              <th className="p-3">Title</th>
              <th className="p-3">File size</th>
              <th className="p-3">Duration</th>
              <th className="p-3">Status</th>
              <th className="p-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={row.id} className="border-b hover:bg-gray-50 transition">
                <td className="p-3 font-medium text-gray-700">{i + 1}</td>
                <td className="p-3">
                  <div className="flex flex-col">
                    <span className="font-semibold">{row.title}</span>
                    {!!row.description && (
                      <span className="text-gray-500 text-xs">
                        {row.description}
                      </span>
                    )}
                  </div>
                </td>
                <td className="p-3 text-gray-700">{row.size || "-"}</td>
                <td className="p-3 text-gray-700">{row.duration || "-"}</td>
                <td className="p-3">
                  <Switch
                    checked={row.active}
                    onChange={() => toggleStatus(row.id)}
                  />
                </td>
                <td className="p-3 flex items-center gap-3">
                  <button className="text-gray-500 hover:text-blue-600">
                    <Edit3 size={18} />
                  </button>
                  <button className="text-gray-500 hover:text-gray-700">
                    <MoreHorizontal size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="w-full h-full">
          <div className="flex justify-between">
            <p className="text-center font-bold text-black text-2xl">
              Episodes (0)
            </p>
            <button
              onClick={() =>
                navigate(
                  `/movie-box/add-movie/add-episode?media_type=series${
                    mediaId ? `&id=${mediaId}` : ""
                  }${seasonId ? `&season_id=${seasonId}` : ""}`
                )
              }
              className="block rounded-3xl font-extrabold w-24 border text-black px-4 py-2 hover:bg-gray-50"
            >
              + Add
            </button>
          </div>
          <div className="flex flex-col items-center gap-4 mt-10">
            <div className="bg-[#57BE921A] rounded-full p-2 w-32 h-32 flex justify-center items-center">
              <img src={Tape} className="w-12 h-12 text-gray-500" alt="tape" />
            </div>
            <span className="text-gray-500">No episodes added yet</span>
            <button
              onClick={() =>
                navigate(
                  `/movie-box/add-movie/add-episode?media_type=series${
                    mediaId ? `&id=${mediaId}` : ""
                  }${seasonId ? `&season_id=${seasonId}` : ""}`
                )
              }
              className="block rounded-3xl font-extrabold w-40 border text-black px-4 py-2 hover:bg-gray-50"
            >
              + Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
